module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNy43NjQiIGhlaWdodD0iMTYuODk1IiB2aWV3Qm94PSIwIDAgMTcuNzY0IDE2Ljg5NSI+CiAgPGRlZnM+CiAgICA8c3R5bGU+CiAgICAgIC5jbHMtMSB7CiAgICAgICAgZmlsbDogbm9uZTsKICAgICAgICBzdHJva2U6ICM4OTg5ODk7CiAgICAgIH0KICAgIDwvc3R5bGU+CiAgPC9kZWZzPgogIDxwYXRoIGlkPSJzdGFyIiBjbGFzcz0iY2xzLTEiIGQ9Ik03LjgwOCwxLjMxOCwxMC4yMiw2LjIwN2w1LjM5NS43ODQtMy45LDMuOC45MjIsNS4zNzNMNy44MDgsMTMuNjMyLDIuOTgyLDE2LjE2OSwzLjksMTAuOCwwLDYuOTkxbDUuMzk1LS43ODRaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxLjA3NCAtMC4xODgpIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/sb-promo.svg
// module id = c2ri
// module chunks = 0